import React, { useEffect } from 'react';
import ProjectEmbed from '../components/ProjectEmbed';

const PAGE_TITLE = '30lb Combat Robot — Skull Crusher | Ethan Freed';
const PAGE_DESCRIPTION = 'Skull Crusher: a removable 3.5 kJ weapon system for a 30 lb combat robot, designed and led by Ethan Freed.';

const SkullCrusherProject = () => {
    useEffect(() => {
        const previousTitle = document.title;
        const description = document.querySelector('meta[name="description"]');
        const previousDescription = description?.getAttribute('content');

        document.title = PAGE_TITLE;
        description?.setAttribute('content', PAGE_DESCRIPTION);

        return () => {
            document.title = previousTitle;
            if (description && previousDescription !== null) {
                description.setAttribute('content', previousDescription);
            }
        };
    }, []);

    return (
        <ProjectEmbed
            title="30lb Combat Robot — Skull Crusher"
            src="/projects/skull-crusher/skull-crusher.html"
        />
    );
};

export default SkullCrusherProject;
